/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-09-13 09:23:14
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-12-12 16:06:11
 * @FilePath: \ioc_base\src\common\utils\map.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
 * @Description: 全局地图对象模块，在main.js中引入该对象，初始化全局地图组件时，将地图组件对象设置至该模块属性，可以全局使用对应的地图对象
 */
import { set } from "lodash";
import app from "./app";
export default {
  MapInstance2D: null,
  MapInstance3D: null,
  showCallBack: null,
  hideCallBack: null,
  handleClick: null,
  setMapInstance2D(instance) {
    this.MapInstance2D = instance;
  },
  setMapInstance3D(instance) {
    this.MapInstance3D = instance;
  },
  showMap2D(callback) {
    app.AppInstance.showMap2D();
    if (this.MapInstance2D) {
      if (callback && typeof callback === "function") {
        callback();
      }
    } else {
      this.showCallBack = callback;
    }
  },
  hideMap2D(callback) {
    app.AppInstance.hideMap2D();
    if (this.MapInstance2D) {
      this.MapInstance2D.clear();
      if (callback && typeof callback === "function") {
        callback();
      }
    } else {
      this.hideCallBack = callback;
    }
    this.clear();
  },
  mapReady() {
    // this.MapInstance2D.resetMapStyle("app");
    if (this.showCallBack && typeof this.showCallBack === "function") {
      app.AppInstance.showMap2D();
      this.showCallBack();
    }
    if (this.hideCallBack && typeof this.hideCallBack === "function") {
      app.AppInstance.hideMap2D();
      this.hideCallBack();
    }
  },
  addClickEvent(callback) {
    // console.log(this.MapInstance2D);
    if (!this.MapInstance2D) {
      this.time = setTimeout(() => {
        this.addClickEvent(callback);
      }, 500);
      return;
    }
    this.time && clearTimeout(this.time);
    this.MapInstance2D.addClickEvent(callback);
  },
  onClick(data) {
    if (this.handleClick && typeof this.handleClick === "function") {
      this.handleClick(data);
    }
  },
  clear() {
    this.showCallBack = null;
    this.hideCallBack = null;
    this.handleClick = null;
  }
};
